<template>
  <div class="mapbox">
    <!-- <div class="closebtn" @click="$emit('goBack')">关闭 ×</div>  -->

    <!-- <div class="imgbox">
      <img src="@/assets/images/taxpic.png" class="image" alt="税源管理图片" />
    </div> -->

    <template v-if="activePage === 1">
      <!-- <button class="arrow" @click="activePage = 2">&#8592;</button> -->
      <div class="details">
        <div class="table-title">税源管理主流程</div>

        <div class="imgbox">
          <img src="@/assets/images/taxpic.png" class="image" alt="税源管理图片" />
        </div>
      </div>
      <button class="arrow" @click="activePage = 2">&#8594;</button>
    </template>

    <template v-if="activePage === 2">
      <button class="arrow" @click="activePage = 1">&#8592;</button>
      <div class="details">
        <!-- <div class="table-title">小程序示例</div> -->

        <div class="screenshots">
          <img src="@/assets/images/tax/tax1.jpg" class="image" alt="税源管理图片" />
          <img src="@/assets/images/tax/tax2.jpg" class="image" alt="税源管理图片" />
          <!-- <img src="@/assets/images/tax/tax3.jpg" class="image" alt="税源管理图片" />
          <img src="@/assets/images/tax/tax4.png" class="image" alt="税源管理图片" /> -->
        </div>
      </div>
      <button class="arrow" @click="activePage = 3">&#8594;</button>
    </template>

    <template v-if="activePage === 3">
      <button class="arrow" @click="activePage = 2">&#8592;</button>
      <div class="details">
        <!-- <div class="table-title">小程序示例</div> -->

        <div class="screenshots">
          <!-- <img src="@/assets/images/tax/tax1.jpg" class="image" alt="税源管理图片" />
          <img src="@/assets/images/tax/tax2.jpg" class="image" alt="税源管理图片" /> -->
          <img src="@/assets/images/tax/tax3.jpg" class="image" alt="税源管理图片" />
          <img src="@/assets/images/tax/tax4.png" class="image" alt="税源管理图片" />
        </div>
      </div>
      <button class="arrow" @click="activePage = 1">&#8594;</button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'TaxDetail',

  data() {
    return {
      activePage: 1
    }
  }
}
</script>

<style scoped>
.mapbox {
  display: flex;
  height: 100%;
  padding: 16px;
  gap: 12px;
  /* flex-direction: column; */
}

.closebtn {
  color: #83ffe1;
  text-align: right;
  margin: 20px 15px;
  cursor: pointer;
}

.detail-img {
  width: 100%;
  height: 80%;
  object-fit: fill;
  border-radius: 8px;
  padding: 15px 20px;
}

.imgbox {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 80%;
    width: 95%;
  }
}
/* 
.image {
  height: 90%;
  width: 95%;
  margin: 0 30px;
} */

.arrow {
  flex-shrink: 0;
  align-self: center;
  background: rgba(0, 180, 220, 0.15);
  border: 1px solid #00cfff;
  color: #00cfff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
}

.details {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 18px 0;
  box-sizing: border-box;
  justify-content: center;
}

.table-title {
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  padding-bottom: 8px;
  flex-shrink: 0;
  /* opacity: 0.85; */
}

.screenshots {
  display: flex;
  gap: 40px;
  justify-content: center;

  img {
    height: 550px;
    /* width: 100%; */
    object-fit: contain;
  }
}
</style>
